import 'jsoneditor/dist/jsoneditor.css';

import { Box, Button } from '@mui/material';
import Editor from 'jsoneditor';
import React, { useEffect, useState } from 'react';

import OberonDialog from '~components/OberonDialog';

type Props = {
  open: boolean;
  onOpen: (editor: Editor) => void;
  onSubmit: (editor: Editor) => void;
  onClose?: () => void;
};

export default function JSONEditorDialog({ open, onOpen, onClose, onSubmit }: Props) {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const [editor, setEditor] = useState<Editor>();
  useEffect(() => {
    if (container) {
      const editor = new Editor(container, {
        mode: 'code',
        mainMenuBar: false,
        statusBar: false,
      });
      setEditor(editor);

      return () => {
        setEditor(undefined);
        editor.destroy();
      };
    }
  }, [container]);

  useEffect(() => {
    if (open && editor) {
      onOpen(editor);
    }
  }, [editor, open]);

  return (
    <OberonDialog
      open={open}
      onSubmit={(e) => {
        e.preventDefault();
        if (editor) {
          onSubmit(editor);
        }
      }}
      onClose={onClose}
      title='Edit JSON Template'
      content={<Box ref={setContainer} sx={{ height: '60vh', minHeight: '300px' }} />}
      actionFooter={
        <>
          <Button variant='text' onClick={onClose}>
            Close
          </Button>
          <Button type='submit' variant='contained' disableElevation color='primary' disabled={!editor}>
            Save
          </Button>
        </>
      }
    />
  );
}
